
import { defineComponent, PropType } from "vue";
import { trans } from "@/globals/translator";
import BlockTitle from "@/components/common/BlockTitle.vue";
import ArticleBlock from "@/components/article/ArticleBlock.vue";
import ArticleCard from "@/components/article/ArticleCard.vue";
//import ArticleCardSkeleton from "@/components/article/ArticleCardSkeleton.vue";
import { ArticleModel } from "@/entities/Article";

export default defineComponent({
  components: {
    BlockTitle,
    ArticleBlock,
    ArticleCard,
    //ArticleCardSkeleton,
  },
  props: {
    articles: Array as PropType<Array<ArticleModel>>,
  },
  setup() {
    return {
      trans,
    };
  },
});
